import { render, staticRenderFns } from "./ModuleConfigForm.vue?vue&type=template&id=6a9be93b&scoped=true&"
import script from "./ModuleConfigForm.vue?vue&type=script&lang=js&"
export * from "./ModuleConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./ModuleConfigForm.vue?vue&type=style&index=0&id=6a9be93b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9be93b",
  null
  
)

export default component.exports